import User from "./User";

export default interface Discussion {
  discussionId: number;
  categoryId: number;
  type: string;
  name: string;
  body: string;
  url: string;
  insertUser?: User;
  lastUser?: User;
  dateLastComment?: Date;
  updateUserID?: number;
  countComments?: number;
  countViews?: number;
  attributes?: {
    status?: string;
    state?: string;
  };
}

export enum DiscussionType {
  discussion = "discussion",
  question = "question",
  idea = "idea",
  event = "event",
}
